import { IoSearchOutline } from "react-icons/io5";
import { Input } from "antd";
const { Search } = Input;
const SearchInput = ({
  value,
  onSearch,
  onChange,
  placeholder = "Search for clients",
  className = "",
}) => {
  return (
    <>
      <Search
        size="large"
        placeholder={placeholder}
        className={`custom-search w-full ${className}`}
        onSearch={onSearch}
        prefix={<IoSearchOutline style={{ color: "#999" }} />}
        onChange={onChange}
        value={value}
      />
    </>
  );
};

export default SearchInput;
